import MediaQuery from 'react-responsive';
import Grid from '#/components/UnifiedRfqs/components/Grid';
import HeadedModal from '@paradigm/design-system/src/components/HeadedModal';

import { useGrfqTrade } from '@paradigm/features/src/unified-rfqs/ui/trade-context';
import { ProductInfo } from '#/components/UnifiedRfqs/components/RfqStrategySummary';
import { MOBILE_BREAKPOINT } from '#/containers/layout/constants';
import useIsMobile from '@paradigm/design-system/src/hooks/useIsMobile';
import {
  MobileRfqInfo,
  RfqDateInfo,
} from '#/components/UnifiedRfqs/components/DetailsModal';

import GrfqTradeDescription from './TradeDescription';
import TradeLegsTable from './TradeLegsTable';

const MODAL_WIDTH = 750;

interface Props {
  isOpen: boolean;
  close: () => void;
}

export default function GrfqTradeDetailsModal({ isOpen, close }: Props) {
  const trade = useGrfqTrade();
  const isMobile = useIsMobile();
  const leftInfo = isMobile ? (
    <RfqDateInfo date={trade.traded} />
  ) : (
    <ProductInfo venue={trade.venue} productCode={trade.product_codes[0]} />
  );

  return (
    <HeadedModal
      title="Trade Recap"
      isOpen={isOpen}
      close={close}
      leftInfo={leftInfo}
      width={MODAL_WIDTH}
      aria-label="unified-rfq trade details modal"
    >
      <MediaQuery maxWidth={MOBILE_BREAKPOINT}>
        <MobileRfqInfo
          venue={trade.venue}
          productCode={trade.product_codes[0]}
          description={trade.description}
        />
      </MediaQuery>
      <Grid cols={1} css="padding: 1rem;">
        <GrfqTradeDescription trade={trade} />
        <TradeLegsTable />
      </Grid>
    </HeadedModal>
  );
}
